import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["disabled", "network", "onClick"];
import React from 'react';
import classNames from 'classnames/bind';
import { Apple, Facebook, Google, Instagram, Tinkoff, Vkiddm, YandexIdWhite } from "../icons";
import style from './SocialButton.css';
var cx = classNames.bind(style);
var ICONS = {
  apple: /*#__PURE__*/React.createElement(Apple, {
    color: "W100",
    size: "md",
    style: {
      transform: 'translateY(-1px)'
    }
  }),
  fb: /*#__PURE__*/React.createElement(Facebook, {
    color: "W100"
  }),
  google: /*#__PURE__*/React.createElement(Google, {
    color: "W100"
  }),
  vk: /*#__PURE__*/React.createElement(Vkiddm, {
    color: "W100"
  }),
  instagram: /*#__PURE__*/React.createElement(Instagram, {
    color: "W100",
    size: "md"
  }),
  tinkoff: /*#__PURE__*/React.createElement(Tinkoff, null),
  yandex: /*#__PURE__*/React.createElement(YandexIdWhite, {
    size: "md"
  })
};

var SocialButton = function SocialButton(_ref) {
  var disabled = _ref.disabled,
      network = _ref.network,
      onClick = _ref.onClick,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("button", _extends({
    className: cx('SocialButton', _defineProperty({}, "SocialButton_".concat(network), network)),
    disabled: disabled,
    onClick: onClick,
    type: "button"
  }, rest), ICONS[network]);
};

export default SocialButton;